<template>
  <div class="auth-input-wrapper">
    <input :class="{ error: !email.isValid || emailIsAlreadyTaken,
          valid: (email.isValid && email.length > 0) }"
      @input="validateWithDebounce"
      @blur="validate"
      v-model="value"
      type="text"
      id="email"
      required
    >
    <label for="email">E-mail</label>
    <p class="error" v-if="emailIsAlreadyTaken">Podany e-mail jest zajęty!</p>
    <p class="error" v-else-if="email.isTooShort">Treść pola jest zbyt krótka!</p>
    <p class="error" v-else-if="email.isTooLong">Treść pola jest zbyt długa!</p>
    <p
      class="error"
      v-if="!email.isAlphanumeric
      && !email.isTooShort
      && !email.isTooLong"
    >Niepoprawny e-mail!</p>
  </div>
</template>

<script>
import { validateEmail, debounce, debounceOffset } from '../authValidation';

export default {
  name: 'EmailAuthInput',
  data() {
    return {
      email: {
        isValid: true,
        isTooShort: false,
        isTooLong: false,
        isAlphanumeric: true,
        length: 0
      }
    };
  },
  computed: {
    value: {
      get() {
        return this.$store.getters.registrationEmail;
      },
      set(value) {
        this.$store.commit('updateRegistrationEmail', value);
      }
    },
    emailIsAlreadyTaken() {
      return this.$store.getters.emailIsAlreadyTaken;
    }
  },
  methods: {
    validateWithDebounce(e) {
      this.$store.dispatch('clearAllAuthErrors');
      debounce(() => {
        this.validate(e);
      }, debounceOffset);
    },
    validate(e) {
      validateEmail(e, this.email);
      this.$store.commit('updateIsRegistrationEmailValid', this.email.isValid);
    }
  }
};
</script>
